import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useLecturerCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';
import { isMobile } from 'react-device-detect';

export interface LecturerSelectBox {
  codeValue?: any;
  boxSize?: string;
  onChangeSelect?: (value: any | number) => void;
}

const LecturerCode = ({
  codeValue,
  boxSize = isMobile ? '100px':'250px',
  onChangeSelect
}: LecturerSelectBox): React.ReactElement => {
    
  /* ======================================================
  * States
  * ====================================================== */
  const [options, setOptions] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');


  /* ======================================================
  * hooks
  * ====================================================== */
  const { lecturerCodeList } = useLecturerCode();  

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const opts : any[] = [];
    //opts.push({value: 'A', label: '전체'})

    if (lecturerCodeList) {
      lecturerCodeList.forEach((item) => {
        if (searchValue.length > 0) {
          opts.push({value: String(item.value), label: item.label})  
        } else if (item.activated == 1 || item.value == codeValue) {
          opts.push({value: String(item.value), label: item.label})  
        }
      })
    }

    setOptions(opts);
    
  }, [lecturerCodeList, codeValue, searchValue]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Select 
      style={{minWidth:boxSize}} 
      maxTagCount={isMobile?2:5}
      value={codeValue}
      placeholder={'강사'}
      onChange={onChangeSelect}
      virtual={false}
      showSearch={true} 
      options={options}       
      optionFilterProp="label" 
      mode="multiple"    
      allowClear={true}      
      filterOption={selectBoxFilterOption}
      searchValue={searchValue}
      onSearch={(value)=>setSearchValue(value)}
    /> 
  );
};

export default LecturerCode;
